<template>
    <div class="finfo-panel" v-if="infoData">
        <div class="finfo-header">
            <div class="finfo-header-left">
                <i :class="['finfo-type-icon fas', infoData.src ? 'fa-file-alt' : 'fa-folder']"></i>
                <div class="finfo-name" :title="infoData.name">{{ infoData.name }}</div>
            </div>
            <button class="finfo-close" @click="$emit('close')">&times;</button>
        </div>
        <div class="finfo-section-label"><i class="fas fa-info-circle"></i> Details</div>
        <div class="finfo-details">
            <div class="finfo-row" v-for="item of detailItems" :key="item.name">
                <span class="finfo-row-label">{{ item.name }}</span>
                <span class="finfo-row-value">{{ item.value }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { formatFileSize, getFileTypeFromExtension } from "../../utils/file-utils"
import { formatIndianDate } from "../../utils/common"

export default {
    emits: ["close"],
    data() {
        return { detailItems: [] }
    },
    mounted() {
        if (this.infoData) {
            this.detailItems = [
                { name: "Type", value: this.infoData.mimeType ? getFileTypeFromExtension(this.infoData.mimeType.split("/")[1]) : "Folder" },
                { name: "Size", value: this.infoData.size ? formatFileSize(this.infoData.size) : "N/A" },
                { name: "Location", value: this.infoData.folderId ? "Folder" : "Root" },
                { name: "Owner", value: "Me" },
                { name: "Modified", value: this.infoData.updatedAt ? formatIndianDate(this.infoData.updatedAt) : '—' },
                { name: "Created", value: this.infoData.createdAt ? formatIndianDate(this.infoData.createdAt) : '—' },
            ]
        }
    },
    props: {
        infoData: { type: Object, default: null },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.finfo-panel { background:white; border:1px solid $gray100; border-radius:10px; box-shadow:$shadowSm; overflow:hidden; position:sticky; top:16px; }
.finfo-header { display:flex; align-items:center; justify-content:space-between; gap:10px; padding:12px 14px; border-bottom:1px solid $gray100; background:$gray50; }
.finfo-header-left { display:flex; align-items:center; gap:8px; min-width:0; }
.finfo-type-icon { font-size:16px; color:$primaryColor; flex-shrink:0; }
.finfo-name { font-size:13px; font-weight:700; color:$gray800; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.finfo-close { width:26px; height:26px; border-radius:6px; border:none; background:transparent; color:$gray400; font-size:18px; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:all $transitionFast; flex-shrink:0; line-height:1; &:hover { background:$gray100; color:$gray700; } }
.finfo-section-label { padding:12px 14px 6px; font-size:11px; font-weight:700; color:$gray500; text-transform:uppercase; letter-spacing:0.3px; display:flex; align-items:center; gap:5px; i { font-size:10px; color:$gray400; } }
.finfo-details { padding:0 14px 14px; }
.finfo-row { display:flex; justify-content:space-between; align-items:center; padding:8px 0; border-bottom:1px solid $gray50; &:last-child { border-bottom:none; } }
.finfo-row-label { font-size:12px; font-weight:500; color:$gray500; }
.finfo-row-value { font-size:12px; font-weight:600; color:$gray800; text-align:right; }
</style>
